import React, { useEffect } from "react";
import GoogleMapReact from "google-map-react";
import "src/Assets/css/ReusuableComponents/aboutMap.css";
import ContactMap from "src/Assets/images/contactMapIcon.svg";
import CloseButton from "src/Assets/images/CloseButton.svg";
import { Box, Dialog } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import styles from "src/Assets/css/home/post.module.css";
import { Modal, Backdrop, Fade } from "@material-ui/core";

// Location pin for single lat/lng
const LocationPin = ({ text }) => (
  <div className="pin">
    <img src={ContactMap} className={styles.LocationPinIcon} alt={text} />
  </div>
);

// Custom styles for Dialog
const useStyles = makeStyles({
  paperWidthSm: {
    borderRadius: 25,
    width: 650,
    overflow: "hidden",
    maxWidth: "none",
  },
});
const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  p: { xs: 2, sm: 3 }, // responsive padding
  borderRadius: "16px",
  outline: "none",
  boxShadow: 24,
  width: {
    xs: "90vw", // phones
    sm: "80vw", // small screens
    md: "70vw", // tablets / small laptops
    lg: "60vw", // desktops
  },
  maxWidth: "900px", // limit on very large screens
  maxHeight: "90vh", // prevent overflow
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

function MapDialog(props) {
  const classes = useStyles();
  const { onClose, open, clickedLocation, displayType } = props;
  const { locAddress, latitude, longitude } = clickedLocation;

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        document.activeElement?.blur();
      }, 100);
    }
  }, [open]);

  const handleClose = () => {
    onClose(false);
  };

  // Fallback location if lat/lng is missing or invalid
  const defaultLocation = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627,
    },
    zoom: 11,
  };

  // CASE 1: Check if both lat & lng are strings and contain commas (boundary case)
  const isBoundaryCase =
    typeof latitude === "string" &&
    typeof longitude === "string" &&
    latitude.includes(",") &&
    longitude.includes(",");

  // CASE 2: Parse boundary coordinates if present
  const coordsArray = isBoundaryCase
    ? latitude.split(",").map((lat, i) => ({
        lat: parseFloat(lat.trim()),
        lng: parseFloat(longitude.split(",")[i].trim()),
      }))
    : [];

  // CASE 3: Decide center point and zoom
  const locationDetails = {
    center: isBoundaryCase
      ? coordsArray[0] // Center at the first polygon point
      : {
          lat:
            latitude && !isNaN(Number(latitude))
              ? Number(latitude)
              : defaultLocation.center.lat,
          lng:
            longitude && !isNaN(Number(longitude))
              ? Number(longitude)
              : defaultLocation.center.lng,
        },
    zoom: isBoundaryCase
      ? 16 // Use tighter zoom for polygon
      : props.zoomLevel && !isNaN(Number(props.zoomLevel))
      ? Number(props.zoomLevel)
      : defaultLocation.zoom,
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      closeAfterTransition
      style={{ zIndex: 9999 }}
      sx={{ zIndex: 9999 }}
    >
      <Box sx={modalBoxStyle}>
        <div className={styles.mapcontainer}>
          <div className={styles.addlocation}>
            <div>{/* <img src={backbutton} alt="backbutton" /> */}</div>
            {displayType !== "photoPreview" && (
              <h5 className={styles.locationheading}>Address</h5>
            )}
            <button
              className={styles.locationSubmitButton}
              onClick={handleClose}
            >
              <img src={CloseButton} alt="close" />
            </button>
          </div>

          <div className="map">
            <div className="google-map">
              {displayType !== "photoPreview" && (
                <input
                  type="text"
                  defaultValue={locAddress}
                  className="searchBar ContactAddress"
                  tabIndex="-1"
                  readOnly
                />
              )}

              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyAXEHjz5uTArWEC0q8-zpu_xXuHXJ2zOl8", // Replace with your actual API key
                }}
                defaultCenter={locationDetails.center}
                defaultZoom={locationDetails.zoom}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => {
                  if (isBoundaryCase && coordsArray.length) {
                    // Draw polygon
                    const polygon = new maps.Polygon({
                      paths: coordsArray,
                      strokeColor: "#373334",
                      strokeOpacity: 0.8,
                      strokeWeight: 2,
                      fillColor: "#707070",
                      fillOpacity: 0.35,
                    });
                    polygon.setMap(map);

                    // Auto-fit bounds to polygon
                    const bounds = new maps.LatLngBounds();
                    coordsArray.forEach((coord) => bounds.extend(coord));
                    map.fitBounds(bounds);
                  }
                }}
              >
                {/* Show pin only when not boundary */}
                {!isBoundaryCase && (
                  <LocationPin
                    lat={locationDetails.center.lat}
                    lng={locationDetails.center.lng}
                    text={locAddress || "Default Location"}
                  />
                )}
              </GoogleMapReact>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default MapDialog;
